import { Backdrop, CircularProgress, Typography, Box, AppBar, Toolbar, Avatar, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import TicketList from "./TicketList";
import { AssignedTickets, CompletedTickets, PendingTickets } from "../viewmodel/FetchTicketsAdmin";
import FilterView from "./FilterView";
import PaginationView from "./PaginationView";

// Icons for a Modern UI
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SearchIcon from '@mui/icons-material/Search';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

// CONAS Brand Colors
const CONAS_BLUE = "#163672";
const CONAS_GREEN = "#69b244";

function AdminMainLayout() {
    let filterReset = {
        ticketId: null,
        ticketHeading: null,
        ticketTool: null,
        ticketDate: null,
        ticketStatus: null,
        ticketType: null,
    }
    const [screen, setScreen] = useState("pending")
    const [ticketData, setTicketData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [currentPage, setCurrentPage] = useState(1)
    const [filterData, setFilterData] = useState({
        ticketId: null, ticketHeading: null, ticketTool: null,
        ticketDate: null, ticketStatus: null, ticketType: null,
    })
    const [filterDataToSend, setFilterDataToSend] = useState({})
    const [currentdata, setCurrentData] = useState("normal")
    const [totalDataCount, setTotalDataCount] = useState(10)

    const handelPendingTickets = async () => {
        setLoading(true)
        setScreen("pending")
        setFilterData(filterReset)
        setFilterDataToSend(filterReset)
        setCurrentPage(1)
        let response = await PendingTickets(filterReset, 1, currentdata)
        setTicketData(response.data.ticket_data)
        setTotalDataCount(Math.ceil(response.data.totalCount / 2))
        setLoading(false)
    }

    const handelCompletedTicket = async () => {
        setLoading(true)
        setScreen("completed")
        setFilterDataToSend(filterReset)
        setFilterData(filterReset)
        setCurrentPage(1)
        let response = await CompletedTickets(filterReset, 1, currentdata)
        setTicketData(response.data.ticket_data)
        setTotalDataCount(Math.ceil(response.data.totalCount / 2))
        setLoading(false)
    }

    const handelAssignedTicket = async () => {
        setLoading(true)
        setScreen("assigned")
        setFilterDataToSend(filterReset)
        setFilterData(filterReset)
        setCurrentPage(1)
        let response = await AssignedTickets(filterReset, 1, currentdata)
        setTicketData(response.data.ticket_data)
        setTotalDataCount(Math.ceil(response.data.totalCount / 2))
        setLoading(false)
    }

    const handelFilterSubmitClick = async () => {
        setCurrentData("filter")
        setFilterDataToSend({ ...filterData })
        if (screen === "pending") {
            setCurrentPage(1)
            let response = await PendingTickets(filterData, 1, currentdata)
            setTicketData(response.data.ticket_data)
            setTotalDataCount(Math.ceil(response.data.totalCount / 2))
        } else if (screen === "assigned") {
            setCurrentPage(1)
            let response = await AssignedTickets(filterData, 1, currentdata)
            setTicketData(response.data.ticket_data)
            setTotalDataCount(Math.ceil(response.data.totalCount / 2))
        } else if (screen === "completed") {
            setCurrentPage(1)
            let response = await CompletedTickets(filterData, 1, currentdata)
            setTicketData(response.data.ticket_data)
            setTotalDataCount(Math.ceil(response.data.totalCount / 2))
        }
    }

    const NextButtonClick = async () => {
        setLoading(true)
        let nextpage = currentPage + 1
        setCurrentPage((prev) => prev + 1)
        if (screen === "pending") {
            let response = await PendingTickets(filterDataToSend, nextpage, currentdata)
            setTicketData(response.data.ticket_data)
        } else if (screen === "assigned") {
            let response = await AssignedTickets(filterDataToSend, nextpage, currentdata)
            setTicketData(response.data.ticket_data)
        } else if (screen === "completed") {
            let response = await CompletedTickets(filterDataToSend, nextpage, currentdata)
            setTicketData(response.data.ticket_data)
        }
        setLoading(false)
    }

    const PrevButtonClick = async () => {
        setLoading(true)
        let previous = currentPage - 1
        setCurrentPage((prev) => prev - 1)
        if (screen === "pending") {
            let response = await PendingTickets(filterDataToSend, previous, currentdata)
            setTicketData(response.data.ticket_data)
        } else if (screen === "assigned") {
            let response = await AssignedTickets(filterDataToSend, previous, currentdata)
            setTicketData(response.data.ticket_data)
        } else if (screen === "completed") {
            let response = await CompletedTickets(filterDataToSend, previous, currentdata)
            setTicketData(response.data.ticket_data)
        }
        setLoading(false)
    }

    const handlePageClick = async (page) => {
        setLoading(true)
        setCurrentPage(page)
        if (screen === "pending") {
            let response = await PendingTickets(filterDataToSend, page, currentdata)
            setTicketData(response.data.ticket_data)
        } else if (screen === "assigned") {
            let response = await AssignedTickets(filterDataToSend, page, currentdata)
            setTicketData(response.data.ticket_data)
        } else if (screen === "completed") {
            let response = await CompletedTickets(filterDataToSend, page, currentdata)
            setTicketData(response.data.ticket_data)
        }
        setLoading(false)
    }

    const handelFilterClearClick = () => {
        setCurrentData("normal")
        if (screen == "pending") handelPendingTickets()
        else if (screen == "assigned") handelAssignedTicket()
        else if (screen == "completed") handelCompletedTicket()
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            let response = await PendingTickets(filterData, currentPage, currentdata);
            setTicketData(response.data.ticket_data);
            setTotalDataCount(Math.ceil(response.data.totalCount / 2))
            setLoading(false);
        };
        fetchData();
    }, []);

    // Reusable Navigation Item Component for Sidebar
    const NavItem = ({ icon, label, active, onClick }) => (
        <Box onClick={onClick} sx={{
            display: "flex", alignItems: "center", gap: 2,
            px: 2.5, py: 1.5, mx: 1.5, my: 0.5,
            borderRadius: "10px", cursor: "pointer",
            backgroundColor: active ? "rgba(255,255,255,0.1)" : "transparent",
            color: active ? "#ffffff" : "rgba(255,255,255,0.6)",
            borderLeft: active ? `4px solid ${CONAS_GREEN}` : "4px solid transparent",
            transition: "all 0.2s ease-in-out",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.1)", color: "#ffffff" }
        }}>
            {icon}
            <Typography sx={{ fontWeight: active ? 600 : 500, fontSize: "0.95rem" }}>{label}</Typography>
        </Box>
    );

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100vw', overflow: 'hidden', backgroundColor: "#f0f4f8" }}>
        
        {/* Sleek Top Toolbar */}
        <AppBar position="static" elevation={0} sx={{ backgroundColor: "white", borderBottom: "1px solid #e2e8f0", zIndex: 10 }}>
            <Toolbar sx={{ minHeight: "64px !important", display: "flex", justifyContent: "space-between", px: { xs: 2, md: 4 } }}>
                
                {/* Mobile Logo */}
                <Box sx={{ display: { xs: "flex", lg: "none" }, alignItems: "center", gap: 1 }}>
                    <ConfirmationNumberIcon sx={{ color: CONAS_BLUE, fontSize: 26, transform: "rotate(-15deg)" }} />
                    <Typography variant="h6" sx={{ color: CONAS_BLUE, fontWeight: 800, letterSpacing: "-0.5px" }}>CONAS</Typography>
                </Box>
                
                {/* Search Bar Placeholder */}
                <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", backgroundColor: "#f1f5f9", px: 2, py: 1, borderRadius: "8px", width: "300px" }}>
                    <SearchIcon sx={{ color: "#94a3b8", fontSize: 20, mr: 1 }} />
                    <Typography sx={{ color: "#94a3b8", fontSize: "0.9rem" }}>Search workspace...</Typography>
                </Box>

                <Box sx={{ flexGrow: { xs: 1, md: 0 } }} /> 
                
                {/* Right Side Icons */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                    <IconButton size="small" sx={{ color: "#64748b", bgcolor: "#f8fafc", "&:hover": { bgcolor: "#f1f5f9" } }}>
                        <NotificationsNoneIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, pl: 3, borderLeft: "1px solid #e2e8f0" }}>
                        <Avatar sx={{ width: 36, height: 36, bgcolor: "#ef4444", fontSize: "14px", fontWeight: "bold" }}>A</Avatar>
                        <Box sx={{ display: { xs: "none", sm: "block" } }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, color: "#1e293b", lineHeight: 1.1 }}>System Admin</Typography>
                            <Typography variant="caption" sx={{ color: "#64748b" }}>Admin Portal</Typography>
                        </Box>
                    </Box>
                </Box>
            </Toolbar>
        </AppBar>

        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: { xs: "column", lg: "row" }, overflow: "hidden" }}>
            
            {/* Premium Sidebar */}
            <Box sx={{ 
                width: { lg: "260px", xs: "100%" }, 
                backgroundColor: CONAS_BLUE, 
                height: { lg: "100%", xs: "auto" },
                display: "flex", 
                flexDirection: { xs: "row", lg: "column" },
                flexShrink: 0,
                position: "relative",
                overflowX: { xs: "auto", lg: "visible" },
                overflowY: "hidden",
                borderBottom: { xs: "1px solid rgba(255,255,255,0.1)", lg: "none" },
                boxShadow: { lg: "4px 0 24px rgba(0,0,0,0.05)" },
                zIndex: 5,
                '&::-webkit-scrollbar': { height: '0px' }
            }}>
                {/* Desktop Logo Area */}
                <Box sx={{ display: { xs: "none", lg: "flex" }, alignItems: "center", gap: 2, p: 3, pt: 4, mb: 1 }}>
                    <Box sx={{ backgroundColor: "rgba(255,255,255,0.1)", borderRadius: "10px", p: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <DashboardCustomizeIcon sx={{ color: CONAS_GREEN, fontSize: 28 }} />
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{ color: "white", fontWeight: 800, letterSpacing: "-0.5px", lineHeight: 1.2 }}>Ticketing</Typography>
                        <Typography variant="caption" sx={{ color: CONAS_GREEN, fontWeight: 600, letterSpacing: "1px", textTransform: "uppercase" }}>Workspace</Typography>
                    </Box>
                </Box>

                <Typography variant="caption" sx={{ display: { xs: "none", lg: "block" }, color: "rgba(255,255,255,0.4)", fontWeight: 700, px: 4, mb: 1, mt: 2, textTransform: "uppercase", letterSpacing: "1px" }}>
                    Menu
                </Typography>

                {/* Nav Links */}
                <Box sx={{ display: "flex", flexDirection: { xs: "row", lg: "column" }, flexGrow: 1, minWidth: "max-content", py: { xs: 1, lg: 0 } }}>
                    <NavItem 
                        active={screen === "pending"} 
                        onClick={handelPendingTickets} 
                        icon={<PendingActionsIcon fontSize="small" />} 
                        label="Pending Tickets" 
                    />
                    <NavItem 
                        active={screen === "assigned"} 
                        onClick={handelAssignedTicket} 
                        icon={<AssignmentIndIcon fontSize="small" />} 
                        label="Assigned Tickets" 
                    />
                    <NavItem 
                        active={screen === "completed"} 
                        onClick={handelCompletedTicket} 
                        icon={<TaskAltIcon fontSize="small" />} 
                        label="Completed Tickets" 
                    />
                </Box>
            </Box>

            {/* Main Content Area */}
            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", overflowX: "hidden" }}>
                <Box sx={{ p: { xs: 2, sm: 3, md: 3 }, flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "flex-start" }}>
                    
                    <Box sx={{ width: "100%", maxWidth: "1200px", display: "flex", flexDirection: "column", gap: 3 }}>
                        
                        <Box sx={{ backgroundColor: "white", p: { xs: 2, md: 3 }, borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 20px rgba(0,0,0,0.02)" }}>
                            <FilterView filterData={filterData} setFilterData={setFilterData} handelFilterSubmitClick={handelFilterSubmitClick} usertype={"Admin"} handelFilterClearClick={handelFilterClearClick} />
                        </Box>
                        
                        {!loading && ticketData && (
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <TicketList ticketData={ticketData} usertype={"Admin"} screen={screen} />
                                <PaginationView currentPage={currentPage} PrevButtonClick={PrevButtonClick} NextButtonClick={NextButtonClick} totalDataCount={totalDataCount} setCurrentPage={handlePageClick} />
                            </Box>
                        )}
                    </Box>

                </Box>
            </Box>

        </Box>

        <Backdrop open={loading} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}>
            <CircularProgress color="inherit" />
        </Backdrop>

      </Box>
    )
}

export default AdminMainLayout;